"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipPosition = void 0;
var getTooltipPosition = function (trigger) {
    var _a = trigger.getBoundingClientRect(), _b = _a.x, triggerLeft = _b === void 0 ? 0 : _b, _c = _a.y, triggerTop = _c === void 0 ? 0 : _c, triggerWidth = _a.width;
    var triggerCenter = triggerLeft + triggerWidth / 2;
    return {
        top: triggerTop,
        left: triggerCenter,
    };
};
exports.getTooltipPosition = getTooltipPosition;
